import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 800.000000 1000.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3917 6703 c-4 -3 -7 -392 -7 -862 l1 -856 -83 -5 -82 -5 -8 -35 c-4
-19 -10 -70 -14 -113 -7 -81 -13 -92 -19 -35 -2 18 -9 68 -16 111 -12 76 -13
77 -43 77 -17 1 -67 2 -111 3 l-80 2 0 -325 0 -325 75 3 c41 2 76 5 78 7 2 1
4 61 4 131 l1 129 14 -75 c7 -41 12 -90 10 -107 -2 -18 0 -33 4 -33 4 0 9 -12
11 -27 3 -26 7 -28 52 -31 27 -2 54 2 60 8 6 6 16 50 22 98 7 56 12 73 13 47
1 -26 4 -35 10 -27 5 8 6 -7 3 -37 -2 -27 -2 -60 1 -73 6 -23 9 -24 67 -18 34
3 64 2 66 -2 3 -5 12 -2 20 6 11 11 14 49 16 163 1 136 2 141 7 56 4 -50 9
-95 13 -98 4 -4 5 19 3 51 l-4 59 10 -60 c5 -33 7 -71 4 -85 -4 -19 -3 -21 5
-10 6 10 10 11 10 3 0 -7 17 -30 38 -51 33 -35 41 -38 77 -35 27 3 36 1 26 -5
-16 -12 69 -21 97 -11 15 6 15 7 -3 12 -11 2 3 3 30 1 33 -3 43 -1 31 4 -18 8
-18 9 -2 15 10 4 24 1 32 -8 9 -8 21 -15 27 -15 7 0 6 4 -3 10 -8 5 -11 13 -6
17 4 4 13 0 20 -10 11 -14 28 -17 90 -17 l76 0 0 -41 0 -40 53 3 c31 2 52 8
52 15 0 6 4 15 9 20 5 5 6 3 2 -4 -4 -7 -3 -13 2 -13 19 0 22 -32 6 -61 -8
-17 -21 -28 -28 -26 -9 4 -13 -11 -13 -56 -1 -61 -1 -63 37 -89 27 -20 50 -28
79 -28 l41 0 0 40 0 40 131 0 132 0 -7 -32 c-20 -93 -20 -97 3 -91 16 4 21 1
21 -16 0 -23 10 -27 28 -9 8 8 15 8 26 -2 23 -18 69 -5 62 18 -7 20 21 26 64
16 l25 -6 -22 -9 c-42 -16 -24 -29 37 -29 l60 0 0 -41 0 -42 50 5 c36 4 47 2
41 -6 -15 -19 -10 -65 8 -69 14 -4 14 -5 -1 -6 -14 -1 -18 -10 -18 -41 l0 -40
40 0 c33 0 40 3 40 20 0 15 7 20 26 20 21 0 24 -4 19 -20 -6 -19 -2 -20 134
-20 l141 0 0 -40 0 -40 84 0 c65 0 85 -3 90 -15 3 -8 1 -15 -4 -15 -6 0 -10
-8 -10 -17 0 -10 4 -14 8 -8 10 14 53 37 58 32 2 -2 -2 -16 -9 -30 -11 -21
-16 -24 -26 -14 -10 9 -12 8 -9 -8 2 -14 -6 -24 -29 -35 -18 -8 -33 -23 -33
-32 0 -10 -5 -18 -11 -18 -5 0 -8 -4 -5 -9 3 -4 -19 -30 -48 -58 -40 -36 -59
-47 -72 -42 -23 8 -34 3 -34 -17 0 -11 4 -12 18 -5 12 6 22 7 28 1 11 -11 130
102 140 132 3 10 11 18 18 18 7 0 19 11 26 25 7 14 16 25 20 25 4 0 29 33 56
73 27 39 51 74 54 77 3 3 26 39 52 80 62 101 119 220 111 233 -3 5 -2 7 4 4
10 -6 77 172 92 245 5 24 17 81 27 128 25 122 26 437 1 575 -26 143 -35 180
-70 275 -31 88 -122 290 -135 300 -4 3 -19 28 -33 55 -21 38 -31 49 -47 47
-13 -2 -25 5 -32 17 -7 14 -7 21 0 21 5 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0
15 3 15 6 0 13 -142 193 -206 263 -59 63 -166 162 -255 236 -52 44 -73 54 -98
50 -19 -4 -21 -3 -8 3 18 7 18 8 0 23 -37 33 -191 127 -258 160 -38 19 -72 37
-75 41 -3 4 -28 17 -55 29 -28 11 -68 29 -90 39 -68 32 -199 80 -215 80 -9 0
-20 4 -25 9 -9 8 -39 17 -235 70 -106 28 -302 58 -460 71 -74 6 -162 13 -196
15 -33 3 -64 2 -67 -2z m2102 -963 c0 -9 -4 -8 -9 5 -5 11 -9 27 -9 35 0 9 4
8 9 -5 5 -11 9 -27 9 -35z m79 -86 c-3 -14 -5 -12 -10 9 -3 19 -2 25 4 19 6
-6 8 -18 6 -28z m-421 -96 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m570 -130 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-800
-40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-377 -108 c0 -5 -2
-10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m1257 -102
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m20 -50 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-1467 -18 c0 -5 -2 -10 -4 -10 -3 0 -8
5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m1037 -92 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m-30 -20 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2
-7 2 -19 0 -25z m-1664 5 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23
-4z m1694 -65 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m498 -58
c-9 -41 -17 -33 -9 9 4 17 9 30 11 27 3 -2 2 -19 -2 -36z m-1008 8 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m502 -20 c-7 -13 -14 -18 -16 -11
-3 7 2 19 9 27 18 20 22 12 7 -16z m-302 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-171 -54 c-3 -8 -11 -14 -18 -13 -10 0 -10 2 0 6 6 2
13 19 13 36 1 25 3 27 6 9 3 -13 2 -30 -1 -38z m1004 24 c0 -5 -4 -8 -10 -8
-5 0 -10 10 -10 23 0 18 2 19 10 7 5 -8 10 -18 10 -22z m-1225 -18 c3 -5 1
-10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m1192 -22 c-3
-7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-2193 -4 c5 -14 4 -15 -9
-4 -17 14 -19 20 -6 20 5 0 12 -7 15 -16z m2220 -49 c3 -9 0 -15 -9 -15 -8 0
-15 7 -15 15 0 8 4 15 9 15 5 0 11 -7 15 -15z m-2041 -22 c-7 -2 -19 -2 -25 0
-7 3 -2 5 12 5 14 0 19 -2 13 -5z m2054 -136 c-2 -23 -3 -1 -3 48 0 50 1 68 3
42 2 -26 2 -67 0 -90z m-2082 103 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2
10 4 10 3 0 8 -4 11 -10z m-548 -32 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m213 13 c0 -5 -7 -12 -16 -15 -14 -5 -15 -4 -4 9 14 17 20 19 20 6z
m13 -38 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m83 -8 c10 -8
14 -15 8 -15 -5 0 -19 7 -30 15 -10 8 -14 15 -8 15 5 0 19 -7 30 -15z m1091
-42 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-1102 9 c-7 -8
-35 7 -35 18 0 6 7 6 20 -2 10 -7 17 -14 15 -16z m-297 -67 l0 -40 -9 40 c-4
22 -8 51 -7 65 l0 25 8 -25 c4 -14 8 -43 8 -65z m1609 53 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-1210 -65 c-3 -10 -5 -2 -5 17 0 19 2 27
5 18 2 -10 2 -26 0 -35z m990 -10 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2
-26 0 -35z m-1010 0 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z
m2225 -11 c-7 -2 -13 -13 -13 -25 -1 -16 -2 -18 -6 -5 -6 22 18 69 25 48 3 -7
0 -16 -6 -18z m-1695 -64 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0
-45z m31 -48 c-7 -11 -8 -10 -5 7 3 12 2 23 -3 25 -4 2 -4 21 -1 43 l5 40 7
-50 c3 -27 2 -57 -3 -65z m-538 90 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0
6 7 10 15 10 8 0 15 -4 15 -10z m987 -22 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2
-7 2 -19 0 -25z m-253 -4 c4 -15 2 -32 -3 -37 -6 -6 -11 -19 -11 -30 0 -10 -4
-15 -10 -12 -5 3 -10 17 -10 30 0 18 4 23 15 19 8 -4 15 -1 15 5 0 6 -4 11
-10 11 -5 0 -10 9 -10 20 0 29 17 25 24 -6z m1466 -61 c-9 -15 -10 -12 -6 16
3 18 7 43 8 55 1 11 3 4 5 -16 2 -21 -1 -46 -7 -55z m-1007 62 c-3 -9 -8 -14
-10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m488 -47 l-9 -33 -1 36 c-1 20 2 39
6 43 13 12 15 -10 4 -46z m-484 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m190 -10 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m53
23 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10 -9z
m-1260 -10 c0 -5 -7 -12 -16 -15 -24 -9 -28 -7 -14 9 14 17 30 20 30 6z m510
-46 c0 -8 -4 -15 -10 -15 -5 0 -7 7 -4 15 4 8 8 15 10 15 2 0 4 -7 4 -15z m50
-15 c0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9 10
-20z m200 -9 c0 -6 -4 -13 -10 -16 -5 -3 -10 -19 -10 -36 0 -16 -4 -29 -9 -29
-5 0 -8 8 -6 18 12 60 16 72 25 72 6 0 10 -4 10 -9z m477 -13 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m263 1 c0 -11 -4 -17 -10 -14 -5 3 -10
13 -10 21 0 8 5 14 10 14 6 0 10 -9 10 -21z m-39 -46 c-12 -20 -14 -14 -5 12
4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-983 -39 c-3 -14 -5 -12 -10 9 -3 19 -2
25 4 19 6 -6 8 -18 6 -28z m729 14 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m-437 2 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6
0 10 -4 10 -10z m470 0 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10
6 0 11 -4 11 -10z m-775 -68 c-6 -7 -35 18 -35 31 0 5 9 2 20 -8 11 -10 18
-20 15 -23z m270 29 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6 21 15 7z
m190 -33 c-19 -55 -26 -70 -30 -66 -6 5 22 78 30 78 2 0 2 -6 0 -12z m1025
-35 c0 -21 -7 -56 -15 -78 l-14 -40 -1 32 c0 17 5 35 11 39 6 3 9 24 7 45 -2
22 0 39 4 39 5 0 8 -17 8 -37z m-523 0 c-15 -16 -17 -16 -17 -1 0 9 6 18 13
21 20 7 22 -2 4 -20z m-475 -15 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3
-1 -11 -7 -17z m975 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m-917 2 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m480 0 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m-1100 -10 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9
-10z m1045 -33 l2 -38 -19 28 -20 28 5 -37 c6 -41 -9 -53 -18 -15 -8 32 11 79
31 75 11 -2 17 -15 19 -41z m-298 -78 c-10 -17 -12 -16 -25 3 -12 16 -12 25
-2 46 l13 27 12 -30 c9 -21 10 -34 2 -46z m729 5 c-3 -9 -6 -18 -6 -20 0 -2
-4 -4 -9 -4 -5 0 -7 9 -4 20 3 11 10 20 15 20 6 0 7 -7 4 -16z m-515 -21 c-12
-20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m530 -41 c-6 -2 -11 -10
-11 -18 0 -8 -4 -14 -10 -14 -5 0 -10 -11 -10 -24 0 -14 -4 -27 -9 -30 -11 -7
4 75 16 83 6 3 14 20 18 36 l9 30 4 -30 c2 -16 -1 -31 -7 -33z m-1101 18 c0
-5 -9 -10 -21 -10 -11 0 -17 5 -14 10 3 6 13 10 21 10 8 0 14 -4 14 -10z m572
-32 c-2 -10 -8 -18 -12 -18 -4 0 -10 8 -12 18 -3 12 1 18 12 18 11 0 15 -6 12
-18z m-282 6 c0 -3 -7 -12 -15 -20 -16 -17 -18 -14 -9 10 6 15 24 23 24 10z
m12 -36 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z m238 7 c0
-8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m37
-37 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m453 -12 c0 -2 -7
-9 -15 -16 -13 -11 -14 -10 -9 4 5 14 24 23 24 12z m10 -36 c0 -5 -4 -10 -10
-10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-29 -30 c4 -3 0 -15
-10 -26 l-17 -21 -11 23 c-6 13 -7 24 -3 24 5 0 11 -6 14 -12 3 -7 5 -4 5 7
-2 31 2 42 8 25 3 -8 9 -17 14 -20z m-514 -2 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-40 -4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m508 -84 c3 -6 -1 -7 -10 -4 -11 5 -16 2 -14 -7 3 -16 -16 -65 -28 -72
-4 -3 -8 8 -9 23 -1 20 3 27 12 23 17 -6 19 13 3 23 -8 4 -7 9 2 15 19 12 36
11 44 -1z"
          />
          <path
            d="M2278 5575 c-15 -8 -29 -24 -33 -35 -3 -11 -10 -20 -13 -20 -8 0 -75
-128 -111 -210 -66 -152 -113 -295 -147 -445 -23 -98 -25 -327 -5 -430 30
-155 97 -355 158 -468 8 -15 32 -60 52 -98 46 -85 78 -109 146 -109 87 0 96
33 37 138 -82 146 -143 299 -162 401 -5 25 -13 73 -19 106 -14 80 -18 222 -8
320 17 173 99 464 188 668 46 103 51 158 17 181 -28 20 -65 20 -100 1z"
          />
          <path
            d="M2705 5381 c-32 -13 -50 -39 -100 -146 -73 -155 -93 -207 -120 -310
-63 -238 -59 -378 15 -610 31 -97 115 -284 142 -315 23 -28 62 -50 88 -50 30
0 70 25 70 45 0 7 -19 46 -43 87 -139 236 -177 492 -116 777 21 96 85 293 133
406 31 73 31 80 6 105 -21 21 -42 24 -75 11z"
          />
          <path
            d="M3124 5240 c-12 -5 -33 -28 -46 -53 -35 -63 -108 -235 -115 -271 -3
-17 -9 -35 -13 -41 -12 -16 -29 -106 -36 -192 -6 -80 17 -258 36 -277 6 -6 10
-21 10 -34 0 -13 9 -44 21 -70 88 -197 115 -232 175 -232 28 0 35 4 40 26 7
26 -3 51 -73 187 -23 44 -53 155 -63 237 -19 142 26 378 109 579 39 93 40 128
5 141 -14 6 -26 10 -27 9 -1 0 -12 -4 -23 -9z"
          />
          <path d="M4000 4380 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M4030 4360 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M4000 4351 c0 -10 29 -36 34 -30 1 2 -6 12 -16 22 -10 9 -18 13 -18
8z"
          />
          <path
            d="M4050 4330 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"
          />
          <path d="M4640 4204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
          <path
            d="M5040 3930 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path d="M5930 3505 c-6 -8 -10 -20 -8 -26 2 -6 12 0 21 15 18 27 8 37 -13 11z" />
          <path d="M5988 3513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M5760 3350 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M5779 3269 c-17 -25 -69 -52 -69 -37 0 6 8 17 18 24 9 7 13 13 7 13
-23 0 -44 -26 -41 -53 3 -21 0 -26 -13 -21 -8 3 -13 3 -9 0 8 -8 -22 -39 -46
-48 -9 -4 -15 -11 -11 -17 3 -5 36 14 73 42 111 86 132 106 118 111 -7 3 -19
-4 -27 -14z"
          />
          <path
            d="M5605 3270 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M5600 3183 c0 -13 5 -23 10 -23 13 0 13 11 0 30 -8 12 -10 11 -10 -7z" />
          <path d="M5535 3110 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" />
          <path
            d="M5574 3102 c-17 -9 -47 -30 -67 -46 -20 -15 -43 -26 -51 -23 -10 4
-13 1 -10 -7 6 -16 0 -21 -38 -30 -17 -4 -28 -2 -28 4 0 5 11 10 25 10 14 0
25 5 25 10 0 13 -13 13 -45 -2 -25 -11 -34 -28 -15 -28 6 0 10 -4 10 -8 0 -13
-63 -31 -95 -27 -28 4 -28 4 -5 -4 28 -10 20 -14 -26 -11 -27 1 -33 -3 -42
-29 -8 -23 -19 -33 -41 -37 -17 -4 -36 -13 -42 -20 -17 -21 -4 -17 69 18 53
25 62 33 44 36 -12 2 -20 8 -17 13 8 12 55 12 55 -1 0 -6 21 1 48 16 121 66
160 88 200 118 93 68 106 81 46 48z"
          />
          <path
            d="M5090 2870 c-19 -4 -28 -8 -20 -10 23 -4 44 1 55 11 5 5 7 8 5 8 -3
-1 -21 -5 -40 -9z"
          />
          <path
            d="M5056 2824 c-21 -14 -53 -26 -71 -27 -18 -1 -31 -5 -29 -8 4 -8 -75
-39 -98 -39 -9 0 -19 -7 -22 -16 -5 -13 -3 -14 6 -7 7 5 36 16 63 23 28 8 61
20 75 27 14 7 29 13 33 13 21 0 97 42 92 50 -7 12 -2 14 -49 -16z"
          />
          <path d="M4633 2713 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path d="M4788 2713 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3208 2703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path
            d="M4683 2697 c-24 -5 -43 -13 -43 -17 0 -8 110 17 119 26 7 7 -31 2
-76 -9z"
          />
          <path d="M4585 2670 l-30 -8 32 -1 c17 0 35 4 38 9 7 11 3 11 -40 0z" />
          <path d="M3258 2653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3420 2630 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
          <path
            d="M4363 2633 c-24 -2 -43 -8 -43 -14 0 -5 10 -7 23 -4 12 3 49 9 82 14
44 6 49 8 20 8 -22 0 -59 -2 -82 -4z"
          />
          <path d="M3483 2613 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path
            d="M3546 2610 c5 -4 37 -10 72 -12 34 -2 59 -1 55 3 -5 3 -37 9 -72 12
-35 3 -59 2 -55 -3z"
          />
          <path
            d="M4230 2610 c-13 -9 -13 -10 0 -9 8 1 26 5 40 9 l25 8 -25 1 c-14 0
-32 -4 -40 -9z"
          />
          <path d="M3728 2593 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M4053 2593 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
          <path d="M4168 2593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3878 2583 c23 -2 61 -2 85 0 23 2 4 4 -43 4 -47 0 -66 -2 -42 -4z" />{' '}
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
